import { Grid, TextField } from "@mui/material";
import React, { ChangeEvent} from "react";
import { useIntl } from "react-intl";

interface AddressFieldProps {
  address: string;
  city: string;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const AddressFields: React.FC<AddressFieldProps> = ({
  address,
  city,
  handleChange,
}) => {
  const intl = useIntl();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
          <TextField
            name="address"
            type="text"
            value={address}
            onChange={handleChange}
            label={intl.formatMessage({
              id: "address",
              defaultMessage: "Address",
            })}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            name="city"
            type="text"
            value={city}
            onChange={handleChange}
            label={intl.formatMessage({
              id: "city",
              defaultMessage: "City",
            })}
            fullWidth
          />
        </Grid>
    </Grid>
  );
};

export default AddressFields;


